<template>
    <div class="flex justify-between items-center">
        <span class="text-[18px] font-bold text-slate-900">{{ title }}</span>
        <a v-if="infoLink" :href="infoLink" class="text-sky-500 hover:underline cursor-pointer">{{ infoText }}</a>
    </div>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        required: true
    },
    infoText: {
        type: String,
        default: ''
    },
    infoLink: {
        type: String,
        default: ''
    }
});
</script>